var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 43,
    fill: "white",
    stroke: "#F68140",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73 46.7517C73 52.0182 70.4014 56.3271 67.0384 56.9655C66.7327 58.0826 65.9684 58.8806 64.8983 59.1998C64.5926 59.3594 64.2869 59.3594 63.8283 59.3594C63.3697 59.3594 62.9111 59.3594 62.6054 59.1998C61.2297 58.721 60.3125 57.4443 60.3125 55.8484V37.655C60.3125 36.2187 61.2297 34.7823 62.4526 34.3036C62.7583 34.144 63.2169 33.9844 63.6755 33.9844C63.9812 33.9844 64.4398 33.9844 64.7455 34.144C65.8155 34.4631 66.7327 35.4207 67.0384 36.5378C67.0384 36.5378 67.0384 36.5378 67.0384 36.6974C67.0384 36.6974 67.0384 36.6974 67.1913 36.6974C70.5542 37.1762 73 41.4852 73 46.7517Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8438 36.7031H62.5616C62.5616 26.5095 54.1937 18.1415 44 18.1415C33.8063 18.1415 25.4384 26.5095 25.4384 36.7031H23.1562C23.1562 25.1402 32.437 15.8594 44 15.8594C55.563 15.8594 64.8438 25.2923 64.8438 36.7031Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6875 37.632V55.7117C27.6875 57.7734 26.1771 59.3594 24.2135 59.3594C22.8542 59.3594 21.4948 58.4078 21.0417 56.9805C20.8906 56.9805 20.8906 56.9805 20.7396 56.9805C17.4167 56.1875 15 51.9055 15 46.6719C15 41.4383 17.5677 37.1563 20.8906 36.5219C21.1927 35.4117 22.099 34.4602 23.1562 34.143C23.4583 33.9844 23.9115 33.9844 24.2135 33.9844C24.6667 33.9844 24.9688 34.143 25.4219 34.3016C26.6302 34.7773 27.5365 36.0461 27.6875 37.632Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1524 68.4219H49.4375V66.2229H54.1524C59.4959 66.2229 62.4819 63.4375 62.4819 58.4531H64.8394C64.9965 64.6103 60.9103 68.4219 54.1524 68.4219Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1312 65.644C49.6803 64.0482 48.3276 62.9844 46.8246 62.9844H41.1132C39.1593 62.9844 37.6562 64.7575 37.6562 67.0625C37.6562 69.3675 39.1593 71.1406 41.1132 71.1406H46.8246C48.3276 71.1406 49.53 70.0768 50.1312 68.481C50.2815 68.1264 50.2815 67.5944 50.2815 67.0625C50.4318 66.5306 50.2815 65.9986 50.1312 65.644Z",
    fill: "#F68140"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.eaebb86e766ccf5a46c3f0f23657ff74.svg";
export { ForwardRef as ReactComponent };